import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MotDuMaire } from 'src/app/shared/models/maire';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-mot-du-maire',
  standalone: false,
  templateUrl: './mot-du-maire.component.html',
  styleUrl: './mot-du-maire.component.scss'
})

export class MotDuMaireComponent {


  constructor(
    private modalService: NgbModal,
    private paramService: ParameterService,
    private fetchService: FecthDataService,
    private localStorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loader: NgxUiLoaderService
  ) {
    this.fetchService.actionCreated$.subscribe(() => {
      // this.getSondage();

      //this.item.created_by = this.localStorage.getUsers()?.data?.user?.reference;
    });

    this.getMotDuMaire();

  }

  item: MotDuMaire = new MotDuMaire()

  selectedFile: File | null = null;
  previewImage: string | ArrayBuffer | null = "assets/images/maire.png";
  motDumaireItems: any = [];
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const allowedImageTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp'];

      const allowedTypes = [...allowedImageTypes];

      if (!allowedTypes.includes(file.type)) {
        this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: "Seuls les fichiers image (PNG, JPG, WEBP…) ou vidéo (MP4, WEBM, OGG) sont autorisés.", life: 20000 });

        // alert('');
        input.value = ''; // Réinitialise le champ
        return;
      }

      this.selectedFile = file;
      this.item.mayor_image = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.previewImage = reader.result;
      };
      reader.readAsDataURL(file);

      //   console.log('Fichier sélectionné :', file);
    }
  }

  updateMotMaire() {
    // console.log("appelé");

    if (!this.item.canSend()) {
      this.messageService.add({
        severity: 'info',
        summary: Constant.suiviTitle,
        detail: this.item.getErrorMessage()
      });
      return;
    }



    // Construction de la requête
    const formData = new FormData();
    formData.append('mayor_name', this.item.mayor_name || '');
    formData.append('mayor_message', this.item.mayor_message || '');
    formData.append('thank_you_phrase', this.item.thank_you_phrase || '');

    if (this.selectedFile) {
      formData.append('mayor_image', this.selectedFile);
    }
    this.loader.start();
    this.paramService.addMotMaire(formData).subscribe(
      (response: any) => {
        this.loader.stop();

        //     console.log("Réponse :", response);
        this.fetchService.notifySeriviceCreated();
        this.modalService.dismissAll();
        this.messageService.add({
          severity: 'success',
          summary: Constant.suiviTitle,
          detail: response.message
        });
        this.item = new MotDuMaire();

      },
      (error: any) => {
        console.error("Erreur :", error);
        this.loader.stop();
        this.fetchService.notifySeriviceCreated();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error.error.message
        });
      }
    );
  }

    mayorImage:any;
  mayorName:any;
  mayorMessage:any;
  remerciement:any;

  getMotDuMaire() {
   // this.loadingMotDumaire = true;
    this.paramService.getMotDumaire().subscribe(
      (response: any) => {
        this.motDumaireItems = response.data;
        this.mayorImage = this.motDumaireItems.mayor_image.value;
        this.mayorName = this.motDumaireItems.mayor_name.value;
        this.mayorMessage = this.motDumaireItems.mayor_message.value;
        this.remerciement = this.motDumaireItems.thank_you_phrase.value;
      //  console.log(" this.mayorImage", this.mayorImage);

        this.previewImage = this.mayorImage;
        this.item.mayor_name = this.mayorName;
        this.item.mayor_message = this.mayorMessage;
        this.item.thank_you_phrase = this.remerciement;

        
        
     //   this.loadingMotDumaire = false;

       //  console.log('la reponse du webservice', response.data);

      },
      (error: any) => {
        //this.isLoading = false;

        //    console.log('une erreur est survenu', error);
      }
    )
  }

     onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/default.jpg';
  }
}